{
  "skip-to-main-content": "Zum Hauptinhalt springen",
  "homepage-title": "Kurse und Aktivitäten buchen",
  "homepage-choose-week": "Woche auswählen",
  "header-membersapp": "Buchungsportal",
  "home": "Startseite",
  "activity": "Aktivität",
  "all": "Alle",
  "sessions": "Aktivität",
  "courses": "Kurse",
  "course": "Kurs",
  "events": "Veranstaltungen",
  "yesterday": "Gestern",
  "today": "Heute",
  "tomorrow": "Morgen",
  "nav-booking": "Buchen",
  "nav-bookings": "Buchungen",
  "nav-tickets": "Tickets",
  "nav-account": "Konto",
  "desktop-nav-booking": "Buchen",
  "desktop-nav-bookings": "Buchungen",
  "desktop-nav-tickets": "Tickets",
  "desktop-nav-account": "Mein Konto",
  "settings-button-aria": "Einstellungen öffnen",
  "book-courses-title": "Buchen Sie Ihre Schwimmschulkurse",
  "book-sessions-title": "Buchen Sie Ihre Sitzungen hier",
  "activity-not-bookable": "Nicht buchbar",
  "activity-locked-out": "Gesperrt",
  "activity-not-bookable-description": "Diese Aktivität kann momentan nicht gebucht werden.",
  "activity-bookable-from": "Diese Aktivität ist buchbar ab",
  "back-to-home": "Zurück",
  "book-button": "Buchen",
  "book-activity": "Aktivität buchen",
  "choose-date": "Wähle ein Datum",
  "to-next-week": "Zur nächsten Woche",
  "to-prev-week": "Zur vorherigen Woche",
  "place": "Platz",
  "places": "Plätze",
  "left": "übrig",
  "enqueue": "In die Warteschlange stellen",
  "booking-reference": "Buchungsreferenz",
  "participants-in-queue": "Teilnehmer in der Warteschlange",
  "participants-booked": "gebucht",
  "participants-has-booked": "Teilnehmer haben gebucht",
  "in-queue": "{{queue}} in Warteschlange",
  "queue": "Warteschlange",
  "queue-position": "Warteschlangenplatz",
  "queue-description": "Bitte beachten Sie, dass es sich um eine Warteschlangenbuchung handelt und nicht bedeutet, dass Sie bereits einen Platz erhalten haben. Wenn ein Teilnehmer storniert, können Sie Ihren Platz bestätigen und die Buchung bezahlen.",
  "full": "Ausgebucht",
  "choose-occasion": "Anlass auswählen",
  "occasions": "Anlässe",
  "first-occasion": "Erster Gelegenheit",
  "participants": "Teilnehmer",
  "participant-already-booked": "Bereits gebucht",
  "of": "von",
  "next-session-title": "Nächste Aktivitätssitzung",
  "next-session-link": "Zur nächsten Aktivitätssitzung navigieren",
  "next-session-exists": "Die nächste Sitzung für diese Aktivität in dieser Woche ist",
  "next-session-empty": "Dies ist die letzte Aktivitätssitzung dieser Aktivität für die Woche. Navigiere zur nächsten Woche und prüfe dort.",
  "statistics-label": "Aktivität",
  "statistics-description": "Anzahl der Personen in der Einrichtung",
  "choose-managed-title": "Teilnehmer auswählen",
  "choose-managed-body": "Wählen Sie Teilnehmer für die Aktivität aus. Wenn Sie ein Kind oder ein anderes Familienmitglied buchen, drücken Sie \"Neuer Benutzer\", um sie zu Ihrer Liste hinzuzufügen.",
  "continue": "Weiter",
  "confirm-title": "Buchung bestätigen",
  "slide-confirm": "Zum Bestätigen ziehen",
  "slide-cancel": "Zum Stornieren ziehen",
  "booking-completed": "Ihre Buchung ist abgeschlossen",
  "booking-reserved": "Ihre Buchung ist reserviert",
  "booking-full-title": "Diese Aktivität ist ausgebucht.",
  "booking-full-queue-description-price": "Sie haben bis zu 24 Stunden Zeit, um die Zahlung zu leisten, sobald Ihre Buchung in der Warteschlange akzeptiert wurde.",
  "booking-full-queue-description-free": "Sie werden automatisch gebucht, wenn ein Platz frei wird. Beachten Sie eine Bestätigungs-E-Mail, die an Sie gesendet wird.",
  "toast-pay-booking": "Sie haben Ihre Buchung noch nicht bezahlt. Bitte zahlen Sie so bald wie möglich, um Ihren Platz nicht zu verlieren!",
  "toast-pay-within": "Sie müssen innerhalb von",
  "toast-pay-now": "Jetzt bezahlen",
  "toast-ticket-activated": "Das Ticket wurde aktiviert",
  "toast-user-created": "Der Benutzer wurde erfolgreich erstellt!",
  "toast-password-changed": "Ihr Passwort wurde erfolgreich geändert",
  "toast-user-not-found": "Der Benutzer konnte nicht gefunden werden. Versuchen Sie, sich abzumelden und erneut anzumelden.",
  "toast-ticket-not-found": "Das Ticket konnte nicht gefunden werden. Bitte überprüfen Sie die Seriennummer und versuchen Sie es erneut.",
  "toast-ticket-not-activable": "Dieses Ticket muss nicht aktiviert werden",
  "toast-old-password-incorrect": "Das alte Passwort ist nicht korrekt",
  "toast-passwords-incorrect": "Die Passwörter stimmen nicht überein",
  "toast-error-password-reuse": "Sie können kein früheres Passwort wiederverwenden.",
  "toast-error-password-capital": "Sie müssen mindestens einen Großbuchstaben im Passwort haben",
  "toast-password-changed-successfully": "Das Passwort wurde erfolgreich geändert. Sie können sich jetzt mit Ihrem neuen Passwort anmelden.",
  "toast-user-already-booked": "Der Benutzer ist bereits für diese Aktivität angemeldet.",
  "toast-something-error": "Etwas ist schief gelaufen. Bitte versuchen Sie es später erneut!",
  "toast-used-email": "Die E-Mail-Adresse ist bereits registriert. Bitte versuchen Sie eine andere.",
  "toast-invalid-ssn": "Die Sozialversicherungsnummer ist ungültig. Überprüfen Sie die Anzahl der Ziffern und versuchen Sie es erneut.",
  "toast-used-ssn": "Die Sozialversicherungsnummer wird bereits verwendet. Wenn Sie bereits ein Konto haben, können Sie sich stattdessen anmelden.",
  "toast-used-ssn-managed": "Die Sozialversicherungsnummer ist bereits registriert.",
  "toast-changed-user": "Sie haben den Benutzer erfolgreich gewechselt",
  "toast-changed-photo": "Das Foto wurde erfolgreich geändert",
  "toast-photo-upload-error": "Etwas ist schief gelaufen, versuchen Sie ein anderes Foto",
  "toast-changed-info": "Die Benutzerinformationen wurden aktualisiert",
  "toast-logout-success": "Sie sind jetzt abgemeldet",
  "toast-account-created": "Das Konto wurde erfolgreich erstellt!",
  "toast-error-cancellation-time": "Die letzte Stornierungsfrist ist verstrichen.",
  "toast-error-user-not-found": "E-Mail-Adresse nicht im System gefunden",
  "toast-error-user-in-queue": "Der Teilnehmer steht bereits in der Warteschlange für diese Aktivität.",
  "toast-error-user-max-bookings": "Der Teilnehmer hat die maximale Anzahl von Buchungen erreicht.",
  "toast-cancelled-booking": "Deine Buchung wurde storniert.",
  "toast-reset-mail-success": "Das Zurücksetzen der E-Mail wurde an die E-Mail-Adresse gesendet",
  "toast-navigated-next-date": "Zum Anlass navigiert",
  "loading-spinner-wait": "Bitte warten...",
  "no-activities-available": "Derzeit sind keine Kurse oder Aktivitäten verfügbar",
  "no-sessions-available": "An diesem Datum sind keine Aktivitäten verfügbar.",
  "no-courses-available": "Derzeit sind keine Kurse verfügbar",
  "no-sessions-available-landing": "Keine buchbaren Sitzungen",
  "no-courses-available-landing": "Keine buchbaren Kurse",
  "no-allotments-available": "Derzeit sind keine Veranstaltungen verfügbar",
  "no-allotments-available-landing": "Keine buchbaren Veranstaltungen",
  "no-products-available": "Derzeit sind keine Produkte verfügbar",
  "need-to-login-title": "Anmeldung erforderlich",
  "need-to-login-description": "Um Kurse und Aktivitäten zu buchen, müssen Sie angemeldet sein.",
  "need-to-login-view-bookings": "Sie müssen angemeldet sein, um Ihre Buchungen anzuzeigen",
  "need-to-login-view-tickets": "Sie müssen angemeldet sein, um Ihre Tickets anzuzeigen",
  "to-login-page": "Zur Anmeldeseite",
  "create-account": "Konto erstellen",
  "create-account-first-description": "Erstellen Sie ein Konto in Ihrem eigenen Namen. Wenn Sie Ihr Kind für die Schwimmschule anmelden möchten, registrieren Sie sich selbst als verantwortlicher Vormund. Sobald Sie eingeloggt sind und buchen möchten, haben Sie die Möglichkeit, Teilnehmer anzugeben und dann den Namen und die Sozialversicherungsnummer des Kindes einzugeben.",
  "create-account-second-title": "Haben Sie Probleme bei der Registrierung?",
  "create-account-second-description": "Wenn Ihre Sozialversicherungsnummer bereits in unserem Kundenregister vorhanden ist (z.B., wenn Sie eine Monatskarte bei uns gekauft haben), können Sie sich nicht als neuer Kunde registrieren, da wir eine eindeutige Sozialversicherungsnummer benötigen. Kontaktieren Sie das Schwimmbad und wir werden Ihnen helfen.",
  "forgot-password": "Passwort vergessen",
  "login": "Anmelden",
  "logout": "Abmelden",
  "duration": "Dauer",
  "close": "Schließen",
  "close-dialog": "Dialog schließen",
  "booking-page-description": "Hier sehen Sie alle bevorstehenden Buchungen. Klicken Sie auf Buchungen, um weitere Informationen dazu anzuzeigen.",
  "booking-page-your-bookings": "Ihre Buchungen",
  "booking-page-cancellations": "Stornierungen",
  "no-bookings-found": "Es wurden noch keine Buchungen vorgenommen",
  "no-cancellations-found": "Es wurden noch keine Stornierungen vorgenommen",
  "show-latest-bookings": "Hier sind Ihre neuesten Buchungen",
  "cancel": "Stornieren",
  "cancelled": "Storniert",
  "activity-cancelled": "Die Aktivität wurde storniert",
  "cancellation-failed": "Die Stornierung ist fehlgeschlagen",
  "activity-cancel": "Aktivität stornieren",
  "activity-cancel-description": "Sie werden die Aktivität stornieren. Bitte beachten Sie, dass dies nicht rückgängig gemacht werden kann.",
  "activity-review-cancellation": "Stornierung bestätigen",
  "day": "Tag",
  "days": "Tage",
  "hour": "Stunde",
  "hours": "Stunden",
  "minute": "Minute",
  "minutes": "Minuten",
  "statistics-people-title": "Aktivität",
  "statistics-people-description": "Anzahl der Personen in der Einrichtung",
  "statistics-not-visited": "Sie haben uns noch nicht besucht",
  "statistics-title": "Ihre Besuche",
  "statistics-visited-description": "Sie haben uns diesen Monat am meisten besucht",
  "latest-notifications": "Neueste Ereignisse",
  "see-all": "Alle anzeigen",
  "ticket-page-header": "Tickets",
  "ticket-page-no-tickets": "Keine Tickets gefunden",
  "ticket-page-no-active-tickets": "Keine aktiven Tickets gefunden",
  "ticket-page-read-more": "Klicken Sie auf das Ticket, das Sie scannen oder genauer betrachten möchten",
  "ticket-page-last-used": "Zuletzt verwendet",
  "ticket-page-active": "Aktiv",
  "ticket-page-not-valid": "Ungültig",
  "ticket-page-clips-left": "Verbleibende Clips",
  "ticket-page-belongs-to": "Gehört zu",
  "ticket-valid": "Gültigkeitsdauer",
  "ticket-invalid": "Ticket ungültig",
  "ticket-active": "Aktiv",
  "ticket-blocked": "Blockiert",
  "ticket-cancelled": "Storniert",
  "ticket-not-active": "Nicht aktiv",
  "ticket-not-used": "Noch nicht verwendet",
  "activate-ticket": "Ticket aktivieren",
  "activate-ticket-description": "Falls Ihr Ticket aktiviert werden muss, können Sie dies hier tun. Tickets, die an der Kasse oder im Webshop gekauft wurden, werden normalerweise automatisch aktiviert.",
  "activate-ticket-number-label": "Seriennummer",
  "activate-ticket-number-description": "Kann beispielsweise wie F3A8014A099133 aussehen",
  "complete-registration-header": "Registrierung abschließen",
  "complete-registration-first-description": "Um Ihr Konto zu erstellen, benötigen Sie auch ein Passwort. Sie haben eine E-Mail mit einem Link erhalten, über den Sie das Passwort auswählen können.",
  "complete-registration-second-description": "Sobald Sie ein Passwort festgelegt haben, können Sie sich einfach anmelden und mit der Buchung beginnen!",
  "complete-registration-shortcuts": "Verknüpfungen zu E-Mail-Seiten",
  "customer-info-header": "Kundeninformationen",
  "customer-info-title": "Kundeninformationen bearbeiten",
  "customer-info-description": "Hier können Sie Ihre Kundeninformationen ändern",
  "save-customer-info": "Klicken Sie auf 'Informationen speichern', wenn Sie fertig sind.",
  "save-customer-info-multi": "Starten Sie mit dem Auswählen eines Benutzers und klicken Sie auf 'Informationen speichern', wenn Sie fertig sind.",
  "customer-info-select-user": "Benutzer auswählen",
  "customer-info-base-info": "Grundinformationen",
  "customer-info-firstname": "Vorname",
  "customer-info-lastname": "Nachname",
  "customer-info-email": "E-Mail-Adresse",
  "customer-info-civic": "Sozialversicherungsnummer",
  "customer-info-phone-home": "Telefonnummer (Zuhause)",
  "customer-info-phone-mobile": "Telefonnummer",
  "customer-info-phone-work": "Telefonnummer (Arbeit)",
  "customer-info-company": "Unternehmen",
  "customer-info-phone-error": "Die Telefonnummer darf nur Zahlen und ein Pluszeichen enthalten",
  "customer-info-address": "Adressinformationen",
  "customer-info-address-Generic": "Adresse",
  "customer-info-address-Delivery": "Lieferadresse",
  "customer-info-address-Invoice": "Rechnungsadresse",
  "customer-info-street": "Straße",
  "customer-info-street-number": "Hausnummer",
  "customer-info-city": "Stadt",
  "customer-info-postal-code": "Postleitzahl",
  "customer-info-postal-code-error": "Darf nur Zahlen enthalten und muss mindestens fünf Ziffern lang sein",
  "customer-info-country": "Land",
  "customer-info-save": "Informationen speichern",
  "required-fields-marked-with": "Pflichtfelder markiert mit",
  "customer-register": "Registrieren",
  "customer-add-user": "Benutzer hinzufügen",
  "purchase-history-title": "Kaufhistorie",
  "account-logged-out-header": "Sie wurden abgemeldet",
  "account-logged-out-description": "Melden Sie sich an, um fortzufahren. Sie benötigen ein Konto, um das Buchungssystem zu verwenden.",
  "account-bookings-title": "Buchungen",
  "account-bookings-description": "Hier können Sie Ihre Buchungen einsehen",
  "account-tickets-title": "Tickets",
  "account-tickets-description": "Hier können Sie Ihre Tickets einsehen",
  "account-purchase-history-title": "Kaufhistorie",
  "account-purchase-history-description": "Sehen Sie Ihre letzten Käufe ein",
  "account-subscription-title": "Abonnements",
  "account-subscription-description": "Sehen Sie sich Ihre Abonnements an",
  "account-subscription-change-card-success": "Die Zahlungskarte wurde geändert",
  "account-subscription-change-card-error": "Die Zahlungskarte konnte nicht geändert werden, bitte versuchen Sie es erneut",
  "account-activate-ticket-title": "Ticket aktivieren",
  "account-activate-ticket-description": "Aktivieren Sie Ihr Ticket hier",
  "account-register-managed-title": "Benutzer hinzufügen",
  "account-register-managed-description": "Benutzer hinzufügen hier",
  "account-photo-title": "Foto ändern",
  "account-photo-description": "Ändern Sie Ihr Foto hier",
  "account-password-title": "Passwort ändern",
  "account-password-description": "Ändern Sie Ihr Passwort hier",
  "table-saledate": "Datum",
  "table-receipt": "Beleg",
  "table-pos": "Kasse",
  "table-total-excl-vat": "Gesamtbetrag exkl. MwSt.",
  "table-total-incl-vat": "Gesamtbetrag",
  "table-price-excl-vat": "Preis exkl. MwSt.",
  "table-price-incl-vat": "Preis",
  "table-actions": "Aktionen",
  "table-placeholder": "Belegnummer filtern",
  "table-columns": "Spalten",
  "table-not-found": "Keine Käufe gefunden",
  "table-previous": "Zurück",
  "table-next": "Weiter",
  "table-page": "Seite {{pageCount}} von {{maxPageCount}}",
  "table-copy-receipt": "Belegnummer kopieren",
  "table-show-receipt": "Beleg anzeigen",
  "table-receipt-description": "Hier können Sie die Details Ihres Kaufs sehen.",
  "table-article": "Produkt",
  "open-menu": "Menü öffnen",
  "search-courses": "Kurse suchen",
  "search-sessions": "Aktivitäten suchen",
  "show-inactive": "Inaktive anzeigen",
  "show-full": "Alle voll belegten anzeigen",
  "show-full-aria-on": "Alle voll belegten ausblenden",
  "show-full-aria-off": "Alle voll belegten anzeigen",
  "show-inactive-aria-on": "Inaktive ausblenden",
  "show-inactive-aria-off": "Inaktive anzeigen",
  "show-cancelled": "Abgeschlossene anzeigen",
  "subscription-header": "Meine Abonnements",
  "subscription-description": "Hier finden Sie Informationen zu Ihren aktuellen und vergangenen Abonnements. Klicken Sie auf ein Abonnement, um weitere Informationen anzuzeigen und Aktionen auszuführen.",
  "subscription-status": "Status",
  "subscription-status-aborted": "Abgebrochen",
  "subscription-status-chargeandfailed": "Zahlung fehlgeschlagen",
  "subscription-status-chargefailed": "Zahlung fehlgeschlagen",
  "subscription-status-registered-label": "Registriert",
  "subscription-status-registered-successful": "Registrierung abgeschlossen",
  "subscription-status-registered": "Aktion erforderlich",
  "subscription-status-cancelled": "Abgebrochen",
  "subscription-status-finalized": "Vollständig bezahlt",
  "subscription-status-active": "Aktiv",
  "subscription-status-pay": "Zahlung erforderlich",
  "subscription-status-frozen": "Eingefroren",
  "subscription-state-aborted-cancelled": "Das Abonnement wurde abgebrochen. Sie müssen ein neues Abonnement bestellen, um unseren Service weiterhin nutzen zu können.",
  "subscription-state-registered": "Dieses Abonnement ist nicht aktiv. Klicken Sie auf den unten stehenden Link, um die erste Zahlung abzuschließen und das Abonnement zu aktivieren.",
  "subscription-state-registeredfinalized": "Dieses Abonnement ist aktiv, und die erste Zahlung wurde durchgeführt.",
  "subscription-state-charged": "Die Zahlung wurde erfolgreich verarbeitet, und das Abonnement ist aktiv.",
  "subscription-state-chargedfailed": "Die Zahlung ist fehlgeschlagen, wahrscheinlich aufgrund unzureichender Guthaben auf der Zahlungskarte oder einer ungültigen Karte. Das Abonnement ist nicht aktiv.",
  "subscription-state-chargedandfailed": "Die Zahlung ist fehlgeschlagen. Bitte kontaktieren Sie den Kundenservice für Unterstützung.",
  "subscription-state-cancelled": "Das Abonnement wurde abgebrochen. Sie können das Abonnement weiterhin für den Zeitraum nutzen, für den Sie bezahlt haben.",
  "subscription-state-active": "Hier können Sie Informationen zu Ihrem Abonnement anzeigen und die Zahlungsmethode ändern.",
  "subscription-start-date": "Startdatum",
  "subscription-end-date": "Enddatum",
  "subscription-type": "Abonnementtyp",
  "subscription-payments-done": "Bezahlte Zahlungen",
  "subscription-payments": "Zahlungen",
  "subscription-last-payment": "Letzte Zahlung",
  "subscription-next-payment": "Nächste Zahlung",
  "subscription-reference": "Referenz",
  "subscription-type-fixed": "Fest",
  "subscription-type-ongoing": "Laufend",
  "subscription-pay": "Bezahlen",
  "subscription-cancel": "Abonnement abbrechen",
  "subscription-cancel-confirmation": "Bitte bestätigen Sie die Kündigung des Abonnements. Dies kann nicht rückgängig gemacht werden!",
  "subscription-change-payment": "Zahlungsmethode ändern",
  "subscription-cancel-success": "Ihr Abonnement wurde erfolgreich abgebrochen",
  "subscription-handle-payment": "Zahlung verwalten",
  "subscription-handle-payment-description": "Hier können Sie Zahlungsmethoden anzeigen und ändern",
  "subscription-handle-payment-active": "Aktive Zahlungsmethode",
  "subscription-handle-payment-change": "Zahlungsmethode ändern",
  "subscription-card-number": "Kartennummer",
  "subscription-card-valid-thru": "Gültig bis, Monat/Jahr",
  "subscription-history-charged": "Bezahlt",
  "subscription-history-failed": "Fehlgeschlagene Abbuchung",
  "subscription-history-due": "Bevorstehend",
  "subscription-history-cancelled": "Storniert",
  "subscription-price-per-month": "Preis pro Monat",
  "subscription-table-title": "Zahlungshistorie",
  "subscription-table-payment": "Zahlung",
  "subscription-table-sum": "Betrag",
  "subscription-table-status": "Status",
  "subscription-table-paid": "Bezahlt",
  "confirm": "Bestätigen",
  "add-new-user": "Neuer Benutzer",
  "managed-header": "Benutzer hinzufügen",
  "managed-description": "Hier können Sie weitere Personen hinzufügen, für die Sie buchen möchten, z. B. Familienmitglieder.",
  "managed-description-extra": "Wenn die Person bereits in unserem System (durch ein vorheriges Einkaufen oder Buchen) vorhanden ist, können Sie die Person hier nicht hinzufügen. Bitte kontaktieren Sie den Personal auf Ihrer lokalen Anlage und wir helfen Ihnen bei der Registrierung.",
  "managed-add-new": "Neuen Benutzer hinzufügen",
  "managed-users": "Benutzer",
  "managed-click-user-to-edit": "Klicken Sie auf einen Benutzer, um die Daten zur Bearbeitung zu öffnen.",
  "managed-edit-user-for": "Daten bearbeiten für {{name}}",
  "managed-add-new-user-header": "Neuen Benutzer hinzufügen",
  "managed-add-new-user-description": "Nachdem Sie z. B. Ihr Kind registriert haben, können Sie Ihr Kind für Kurse und Aktivitäten buchen.",
  "photo-header": "Foto",
  "photo-description": "Denken Sie daran, dass das Personal vor Ort Sie auf dem Foto erkennen können muss.",
  "photo-alt": "Foto von",
  "photo-change": "Foto ändern",
  "photo-upload-header": "Neues Bild hochladen",
  "photo-upload-description": "Hier können Sie ein neues Foto aufnehmen oder ein Foto von Ihrem Gerät hochladen.",
  "photo-change-image": "Bild auswählen",
  "password-header": "Passwort ändern",
  "password-header-reset": "Passwort zurücksetzen",
  "password-header-reset-title": "Zurücksetzen",
  "password-new-description": "Wählen Sie ein neues Passwort für Ihr Konto. Ihr Passwort wird besonders sicher, wenn es sowohl Buchstaben als auch Zahlen enthält.",
  "password-description": "Hier können Sie Ihr Passwort ändern. Geben Sie zuerst Ihr aktuelles Passwort und dann Ihr neues Passwort ein.",
  "password-reset-description": "Geben Sie Ihre E-Mail-Adresse ein und klicken Sie auf Senden, um eine E-Mail mit einem Link zum Zurücksetzen Ihres Passworts zu erhalten. Bitte überprüfen Sie Ihren Spam-Ordner, falls Sie keine E-Mail erhalten.",
  "password-old": "Aktuelles Passwort",
  "password-new": "Neues Passwort",
  "password-confirm-new": "Neues Passwort bestätigen",
  "password-confirm-change": "Passwort ändern",
  "search-close": "Schließen",
  "search-title": "Suchen...",
  "search-placeholder": "Kurse und wöchentliche Aktivitäten, Name, Beschreibung, ID...",
  "search-no-results": "Keine Ergebnisse gefunden",
  "badge-not-paid": "Nicht bezahlt",
  "badge-queue": "In Warteschlange",
  "badge-cancelled": "Storniert",
  "badge-paid": "Bezahlt",
  "dark-theme": "Dunkles Thema",
  "language-change": "Sprache ändern",
  "language-change-to": "Sprache ändern zu",
  "language-swedish": "Schwedisch",
  "language-english": "Englisch",
  "language-danish": "Dänisch",
  "language-german": "Deutsch",
  "language-spanish": "Spanisch",
  "payment": "Zahlung",
  "install-app-maybe-later": "Vielleicht später",
  "install-app-dont-show-again": "Nicht mehr anzeigen",
  "install-app-install": "Installieren",
  "install-app-our": "Installiere unsere App",
  "install-app-description": "Für das beste Erlebnis wird empfohlen, die App zu installieren. Drücken Sie die Taste, um zu installieren.",
  "install-app-description-ios": "Installieren Sie unsere App, indem Sie auf",
  "install-app-description-ios-update": "Aktualisiere unsere App, indem du drückst",
  "install-app-description-update": "Vielen Dank für das Aktualisieren der App! Drücken Sie die Schaltfläche und starten Sie erneut mit der Buchung. Die alte App auf dem Startbildschirm kann dann entfernt werden.",
  "install-app-confirmation-title": "Sind Sie sicher?",
  "install-app-confirmation-description": "Sie werden keine Erinnerung mehr erhalten, unsere App zu installieren. Wenn Sie es sich anders überlegen, können Sie auf",
  "install-app-confirmation-continue": "und dann \"App installieren\".",
  "install-app-confirmation-continue-firefox": "und dann \"Installieren\".",
  "install-app-confirmation-samsung-continue-1": "und dann",
  "install-app-confirmation-samsung-continue-2": "\"Zur Startseite hinzufügen\" und dann \"Startbildschirm\".",
  "install-app-confirmation-safari-continue-1": "und dann scrollen und drücken:",
  "install-app-confirmation-safari-continue-2": "Zur Startseite hinzufügen",
  "install-app-samsung-warning-title": "Für Sie mit Samsung Browser",
  "install-app-samsung-warning-description": "Android behandelt alle Web-Apps, die mit Samsung Browser installiert wurden, als unsicher. Wählen Sie, ob Sie sie trotzdem installieren möchten oder einen anderen Browser verwenden möchten.",
  "form-error-firstname": "Vorname ist erforderlich",
  "form-error-firstname-long": "Der Vorname darf nicht länger als 100 Zeichen sein.",
  "form-error-lastname": "Nachname ist erforderlich",
  "form-error-lastname-long": "Der Nachname darf nicht länger als 100 Zeichen sein.",
  "form-error-mail": "E-Mail ist erforderlich",
  "form-error-mail-invalid": "Ungültige E-Mail-Adresse",
  "form-error-civic-short": "Die Sozialversicherungsnummer muss mindestens 10 Ziffern enthalten",
  "form-error-civic-invalid": "Ungültige Sozialversicherungsnummer",
  "form-error-zip": "Postleitzahl ist erforderlich",
  "form-error-zip-invalid": "Ungültige Postleitzahl",
  "form-error-password-short": "Passwort muss mindestens 5 Zeichen lang sein",
  "form-error-password-long": "Passwort darf nicht länger als 100 Zeichen sein",
  "form-error-phone": "Telefonnummer ist erforderlich",
  "form-error-phone-invalid": "Die Telefonnummer muss zwischen 10 und 15 Nummern umfassen",
  "form-error-email-invalid": "Ungültige E-Mail-Adresse",
  "form-error-email-long": "E-Mail-Adresse darf nicht länger als 255 Zeichen sein",
  "form-error-phone-long": "Telefonnummer darf nicht länger als 20 Zeichen sein",
  "form-error-street-long": "Straßenadresse darf nicht länger als 255 Zeichen sein",
  "form-error-street-number-long": "Hausnummer darf nicht länger als 10 Zeichen sein",
  "form-error-city-long": "Stadt darf nicht länger als 100 Zeichen sein",
  "form-error-country-long": "Land darf nicht länger als 100 Zeichen sein",
  "form-error-photo-required": "Foto ist erforderlich",
  "form-error-field-required": "{{field}} ist erforderlich",
  "form-error-field-invalid": "Ungültiger {{field}}",
  "form-show-old-password": "Zeigen Sie Ihr altes Passwort auf dem Bildschirm",
  "form-hide-old-password": "Verbergen Sie Ihr altes Passwort auf dem Bildschirm",
  "form-show-password": "Zeigen Sie Ihr neues Passwort auf dem Bildschirm",
  "form-hide-password": "Verbergen Sie Ihr neues Passwort auf dem Bildschirm",
  "form-show-verification-password": "Zeigen Sie Ihr neues Bestätigungspasswort auf dem Bildschirm",
  "form-hide-verification-password": "Verbergen Sie Ihr neues Bestätigungspasswort auf dem Bildschirm",
  "form-phone-short": "Die Telefonnummer ist zu kurz",
  "form-phone-long": "Die Telefonnummer ist zu lang",
  "form-phone-invalid": "Verwenden Sie nur Zahlen für die Telefonnummer",
  "cookies-title": "Cookies",
  "cookies-description": "Wir verwenden notwendige Cookies auf der Website, um sicherzustellen, dass sie ordnungsgemäß funktioniert und Ihnen das bestmögliche Erlebnis bietet.",
  "cookies-link": "Mehr über unsere Cookies erfahren",
  "cookies-consent-ok": "OK",
  "cookies-consent-decline": "Ablehnen",
  "not-found-title": "Verlorener Link",
  "not-found-description": "Es sieht so aus, als ob der Link, den Sie erreichen möchten, verloren gegangen ist. Klicken Sie auf die Schaltfläche, um zur Startseite zurückzukehren.",
  "not-found-button": "Zur Startseite",
  "not-found-eyebrow": "Fehler · Seite nicht gefunden",
  "not-found-heading": "Diese Seite ist verschwunden",
  "not-found-body": "Sie wurde vielleicht verschoben, umbenannt oder hat nie existiert. Wir behalten es auf jeden Fall im Auge.",
  "not-found-back-home": "Zur Startseite",
  "not-found-go-back": "Zurück",
  "not-found-heading-course": "Dieser Kurs wurde nicht gefunden",
  "not-found-body-course": "Der Kurs wurde möglicherweise entfernt, oder der Link ist fehlerhaft. Sehen Sie sich stattdessen unsere Kurse an.",
  "not-found-heading-session": "Diese Aktivität wurde nicht gefunden",
  "not-found-body-session": "Die Aktivität wurde möglicherweise entfernt, oder der Link ist fehlerhaft. Sehen Sie sich stattdessen unsere Aktivitäten an.",
  "not-found-heading-allotment": "Diese Veranstaltung wurde nicht gefunden",
  "not-found-body-allotment": "Die Veranstaltung wurde möglicherweise entfernt, oder der Link ist fehlerhaft. Sehen Sie sich stattdessen unsere Veranstaltungen an.",
  "not-found-heading-product": "Dieses Ticket wurde nicht gefunden",
  "not-found-body-product": "Das Ticket wurde möglicherweise entfernt oder ist ausverkauft, oder der Link ist fehlerhaft. Sehen Sie sich stattdessen unsere Tickets an.",
  "not-found-heading-articlegroup": "Diese Kategorie wurde nicht gefunden",
  "not-found-body-articlegroup": "Die Kategorie wurde möglicherweise entfernt oder umbenannt, oder der Link ist fehlerhaft.",
  "accessibility-title": "Barrierefreiheit",
  "offline-title": "Offline",
  "filter-title": "Filtern",
  "sorting-facility-title": "Einrichtung",
  "sorting-tag-title": "Markierung",
  "sorting-showing-facilities": "{{count}} Einrichtungen valgt",
  "sorting-showing-tags": "{{count}} Markierungen valgt",
  "update": "Aktualisieren",
  "update-title": "Aktualisiere unsere App",
  "update-description": "Unsere App wurde aktualisiert und Sie müssten sie möglicherweise neu installieren. Drücken Sie die Schaltfläche unten, um den Link zu kopieren. Öffnen Sie dann den Link in Ihrem regulären Webbrowser und installieren Sie die App.",
  "update-copy": "Installationslink kopieren",
  "update-copied": "Link kopiert",
  "update-finished": "Wenn die Installation abgeschlossen ist, können Sie hier im Browser fortfahren oder die App öffnen.",

  "course-detail-title": "{{courseName}} Kursinformationen",
  "course-detail-description": "Hier können Sie Informationen über den Kurs {{courseName}}, Termine und Zeiten einsehen und sich anmelden.",
  "session-detail-title": "{{sessionName}} Sitzungsinformationen",
  "session-detail-description": "Hier können Sie Informationen über die Sitzung {{sessionName}}, Datum und Uhrzeit einsehen und sich anmelden.",
  "allotment-detail-title": "{{allotmentName}} Veranstaltungsinformationen",
  "allotment-detail-description": "Hier können Sie Informationen über die Veranstaltung {{allotmentName}}, Datum und Uhrzeit einsehen und sich anmelden.",
  "allotments": "Veranstaltungen",
  "products": "Tickets",
  "ticket": "Ticket",
  "product": "Produkt",
  "overview": "Übersicht",
  "description": "Beschreibung",
  "session-information": "Aktivitätsinformationen",
  "course-information": "Kursinformationen",
  "bookable-from": "Buchbar ab",
  "number-of-occasions": "Anzahl der Termine",
  "number-of-places": "Anzahl der Plätze",
  "number-of-booked": "Anzahl gebucht",
  "course-id": "Kurs-ID",
  "instructor": "Instruktor",
  "contact": "Kontakt",
  "length": "Länge",
  "choose-participant": "Teilnehmer wählen",
  "create-new": "Neu erstellen",
  "participant": "Teilnehmer",
  "price-group": "Preisgruppe",
  "base": "Basis",
  "price-includes": "Der Preis beinhaltet MwSt. und Gebühren",
  "book": "Buchen",
  "book-course": "Kurs buchen",
  "book-session": "Session buchen",
  "book-allotment": "Aktivität buchen",
  "login-to-book": "Anmelden zum Buchen",
  "persons": "Personen",
  "time": "Zeit",
  "add-to-cart": "In den Warenkorb",
  "cart": "Warenkorb",
  "cart-empty": "Ihr Warenkorb ist leer",
  "cart-total": "Gesamt",
  "cart-checkout": "Zur Kasse",
  "cart-continue-shopping": "Weiter einkaufen",
  "cart-open": "Warenkorb öffnen",
  "cart-close": "Warenkorb schließen",
  "cart-decrease-quantity": "Menge um 1 verringern",
  "cart-increase-quantity": "Menge um 1 erhöhen",
  "cart-remove-item": "Entfernen",
  "categories": "Kategorien",
  "article-groups": "Övrigt",
  "our-activities": "Unsere Aktivitäten",
  "our-activities-description": "Hier sind unsere kommenden Aktivitäten, Sie können auch wählen, alle Aktivitäten anzuzeigen.",
  "quantity": "Menge",
  "product-detail-title": "{{productName}} Produktinformationen",
  "product-detail-description": "Hier können Sie Informationen über das Produkt {{productName}} sehen",
  "no-description-available": "Keine Beschreibung verfügbar",
  "multi-ticket": "Familienticket",
  "form-personal-info": "Persönliche Daten",
  "form-personal-info-description": "Bitte füllen Sie die untenstehenden Angaben aus, um fortzufahren",
  "form-firstname": "Vorname",
  "form-lastname": "Nachname",
  "form-email": "E-Mail-Adresse",
  "form-civic": "Sozialversicherungsnummer",
  "form-civic-placeholder": "JJJJMMTT-NNNN",
  "form-phone": "Telefonnummer",
  "form-address": "Adresse",
  "form-street": "Straße",
  "form-street-number": "Hausnummer",
  "form-zip-code": "Postleitzahl",
  "form-city": "Stadt",
  "form-country": "Land",
  "form-photo": "Foto",
  "form-photo-exceed-size": "Foto überschreitet maximale Größe",
  "form-photo-exceed-size-max-files": "Sie können nur ein Maximum von {{maxFiles}} Dateien hochladen.",
  "form-invalid-file-type": "Die Dateityp {{fileType}} ist nicht akzeptiert.",
  "upload-file": "Datei hochladen",
  "uploaded-image": "Hochgeladenes Bild",
  "drop-image-or-browse": "Lassen Sie Ihr Bild hier fallen oder klicken Sie zum Durchsuchen",
  "max-size": "Maximale Größe: {{size}}MB",
  "remove-image": "Bild entfernen",
  "crop": "Zuschneiden",
  "crop-close": "Verwerfen",
  "crop-error": "Beim Zuschneiden ist etwas schief gelaufen!",
  "profile-image": "Profilbild",
  "image-cropper-alt": "Bildzuschneidewerkzeug",
  "loading": "Lädt...",
  "settings": "Einstellungen",
  "settings-description": "Ändern Sie Ihre Sprache, Währung und Ihr Design",
  "language": "Sprache",
  "currency": "Währung",
  "theme": "Design",
  "change-language": "Sprache ändern",
  "change-language-to": "Sprache ändern zu",
  "choose-theme": "Wählen Sie ein Design",
  "theme-light": "Hell",
  "theme-dark": "Dunkel",
  "theme-system": "System",
  "close-settings": "Einstellungen schließen",
  "current-language": "Aktuelle Sprache",
  "flag": "Flagge",
  "out-of-stock": "Ausverkauft",
  "product-type": "Produkttyp",
  "regular-products": "Reguläre Produkte",
  "gift-certificate": "Geschenkgutschein",
  "gift-certificates": "Geschenkgutscheine",
  "multi-tickets": "Multi-Tickets",
  "packages": "Pakete",
  "personal-tickets": "Persönliche Tickets",
  "personal-ticket-fill-out-fields": "Geben Sie die Daten der Person ein, die das Ticket nutzen wird",
  "category": "Kategorie",
  "sizes": "Größen",
  "no-products-found": "Keine Produkte entsprechen den ausgewählten Filtern.",
  "results": "Ergebnisse",
  "filters": "Filter",
  "search-products": "Produkte suchen...",
  "clear-search": "Suchfeld leeren",
  "sort-by": "Sortieren nach",
  "name-ascending": "Name A-Z",
  "name-descending": "Name Z-A",
  "price-ascending": "Niedrigster Preis",
  "price-descending": "Höchster Preis",
  "search-label": "Suchen",
  "search-allotments": "Aktivitäten suchen...",
  "location": "Einrichtung wählen",
  "all-locations": "Standorte",
  "date-range": "Von- und bis Datum",
  "no-allotments-found": "Keine Aktivitäten gefunden",
  "time-ascending": "Zeit (aufsteigend)",
  "time-descending": "Zeit (absteigend)",
  "date-not-available": "Datum nicht verfügbar",
  "go-to-prev-month": "Gehe zum vorherigen Monat {{monthName}}",
  "go-to-next-month": "Gehe zum nächsten Monat {{monthName}}",
  "go-to-prev-week": "Gehe zur vorherigen Woche {{previousWeek}}",
  "go-to-next-week": "Gehe zur nächsten Woche {{nextWeek}}",
  "select-date": "Datum auswählen",
  "select-tickets": "Tickets auswählen",
  "exceeds-capacity": "Überschreitet Kapazität",
  "spots-remaining": "Plätze übrig",
  "pick-date": "Datum wählen",
  "allotment-information": "Aktivitätsinformationen",
  "allotment-id": "Aktivitäts-ID",
  "available-courses": "Verfügbare Kurse",
  "available-sessions": "Verfügbare Sitzungen",
  "available-occasions": "Verfügbare Gelegenheiten",
  "places-remaining": "Plätze übrig",
  "date": "Datum",
  "change-card-view-to": "Wechseln zu {{cardViewType}}",
  "grid-view": "rasteransicht",
  "list-view": "listenansicht",
  "abort": "Abbrechen",
  "invalid-additional-field": "Ungültiges Format für {{fieldName}}",
  "select-tickets-per-category": "Wählen Sie die Anzahl der Tickets pro Kategorie",
  "free-of-charge": "Kostenlos",
  "places-left": "{{count}} Plätze übrig",
  "enter-additional-information": "Zusätzliche Informationen eingeben",
  "enter-field": "{{field}} eingeben",
  "could-not-find-activity": "Aktivität nicht gefunden",
  "could-not-find-product": "Produkt nicht gefunden",
  "move-occasions-title": "Tickets umbuchen",
  "move-occasions-back-to-bookings": "Zurück zu meinen Buchungen",
  "move-occasions-step-of": "Schritt {{current}} von {{total}} — {{label}}",
  "move-occasions-step-intro": "Einführung",
  "move-occasions-step-booking": "Buchung wählen",
  "move-occasions-step-datetime": "Datum & Uhrzeit",
  "move-occasions-step-confirm": "Bestätigen",
  "move-occasions-step-code": "Code",
  "move-occasions-step-done": "Fertig",
  "move-occasions-choose-title": "Buchung zum Umbuchen wählen",
  "move-occasions-choose-subtitle": "Wir haben folgende Buchungen auf Ihrem Konto gefunden.",
  "move-occasions-datetime-title": "Neues Datum und Uhrzeit wählen",
  "move-occasions-choose-time": "Uhrzeit wählen",
  "move-occasions-time-helper": "Durchgestrichene Zeiten sind ausgebucht.",
  "move-occasions-confirm-title": "Umbuchung bestätigen",
  "move-occasions-confirm-helper": "Bitte prüfen Sie die Angaben vor der Bestätigung.",
  "move-occasions-label-activity": "Aktivität",
  "move-occasions-label-current": "Ursprüngliche Buchung",
  "move-occasions-label-new": "Umbuchen auf",
  "move-occasions-label-quantity": "Anzahl der Tickets",
  "move-occasions-otp-title": "Mit PIN-Code bestätigen",
  "move-occasions-otp-subtitle": "Geben Sie Ihren vierstelligen Code ein, um die Umbuchung zu bestätigen. Den PIN-Code finden Sie in der Buchungsbestätigungs-E-Mail.",
  "move-occasions-otp-label": "Vierstelliger Bestätigungscode",
  "move-occasions-success-title": "Ihre Umbuchung ist abgeschlossen",
  "move-occasions-success-summary": "{{title}} ist jetzt auf {{dateTime}} umgebucht, {{qty}} {{unit}}.",
  "move-occasions-next": "Weiter",
  "move-occasions-back": "Zurück",
  "move-occasions-continue": "Fortfahren",
  "move-occasions-submit": "Umbuchung bestätigen",
  "move-occasions-to-bookings": "Zurück zur Buchungsseite",
  "move-occasions-ticket": "Ticket",
  "move-occasions-tickets": "Tickets",
  "move-occasions-loading": "Wird geladen…",
  "move-occasions-no-bookings": "Keine umbuchbaren Buchungen gefunden.",
  "move-occasions-error-missing-token": "Die Buchung konnte nicht gefunden werden. Kopieren Sie den gesamten Link in der Bestätigungs-E-Mail und versuchen Sie es erneut.",
  "move-occasions-error-bad-token": "Die Tickets konnten nicht gefunden werden. Kopieren Sie den gesamten Link in der Bestätigungs-E-Mail und versuchen Sie es erneut.",
  "move-occasions-error-illegal-pin": "Falscher PIN-Code, richtigen Code eingeben und erneut versuchen",
  "move-occasions-error-no-occasions": "Es gibt keinen Termin, von dem verschoben werden kann",
  "move-occasions-error-too-close": "Sie haben einen Termin gewählt, der zu nah am ursprünglichen liegt. Wählen Sie einen späteren und versuchen Sie es erneut.",
  "move-occasions-error-invalid-parameter": "Etwas ist schiefgelaufen. Laden Sie die Seite neu und versuchen Sie es erneut.",
  "move-occasions-error-api": "Etwas ist schiefgelaufen. Laden Sie die Seite neu und versuchen Sie es erneut.",
  "cookies-policy-title": "Cookie-Richtlinie",
  "cookies-what-are-cookies": "Was sind Cookies?",
  "cookies-what-are-cookies-description": "Cookies sind kleine Textdateien, die in Ihrem Browser gespeichert werden, wenn Sie die Website besuchen. Wir verwenden Cookies, damit die Website optimal funktioniert, zum Beispiel um Sie an Ihrem Benutzerkonto angemeldet zu halten, Artikel in den Warenkorb zu legen oder die Sprache zu wechseln.",
  "cookies-our-cookies": "Welche Arten von Cookies verwenden wir?",
  "cookies-our-cookies-description": "Es gibt verschiedene Arten von Cookies, aber unser Webshop verwendet ausschließlich notwendige Cookies. Diese Cookies erfordern nicht Ihre Einwilligung, sondern sind erforderlich, um den Webshop nutzen zu können.",
  "cookies-names": "Name",
  "cookies-purpose": "Zweck",
  "cookies-storage-time": "Speicherdauer",
  "cookies-save-your-culture": "Speichert Ihre Sprach- und regionalen Einstellungen (z.B. sv-SE).",
  "cookies-session-or-until-you-change-language": "Sitzung oder bis Sie die Sprache ändern",
  "cookies-language-setting-used-by-translation-system": "Sprach- und regionalen Einstellungen, die von dem Übersetzungssystem verwendet werden, synchronisiert mit",
  "cookies-language-setting-used-by-translation-system-description": "Sprach- und regionalen Einstellungen, die von dem Übersetzungssystem verwendet werden, synchronisiert mit",
  "cookies-save-currency": "Speichert die Währung, in der Preise angezeigt werden.",
  "cookies-save-currency-description": "Sitzung oder bis Sie die Währung ändern",
  "cookies-save-saleid": "Verknüpft Ihren Browser mit der laufenden Warenkorb/Buchung, sodass Produkte und Tickets zwischen Seitenansichten bestehen bleiben.",
  "cookies-save-saleid-description": "Sitzung (gelöscht, wenn die Bestellung abgeschlossen oder der Warenkorb geleert wird)",
  "cookies-save-membersapp-consent": "Erinnert Sie daran, dass Sie die Informationen über Cookies in der Bannner am unteren Rand der Seite akzeptiert haben.",
  "cookies-one-year": "1 Jahr",
  "cookies-save-membersapp-theme": "Speichert Ihre Auswahl von hell, dunkel oder System-Design.",
  "cookies-manage-cookies-in-your-browser": "So verwalten Sie Cookies",
  "cookies-manage-cookies-in-your-browser-description": "Wenn Sie nicht möchten, dass Cookies auf Ihrem Computer gespeichert werden, können Sie die Funktion in den Einstellungen Ihres Browsers deaktivieren. Das kann jedoch dazu führen, dass bestimmte Funktionen auf dieser Website nicht wie vorgesehen funktionieren. ",
  "cookies-security": "Sicherheit",
  "cookies-security-description": "Sensible Informationen, wie z.B. Kreditkartennummern bei der Zahlung, werden immer verschlüsselt (SSL/TLS) übertragen. Die Informationen werden nicht von dieser Website gespeichert, sondern von dem Zahlungsanbieter verarbeitet."
}
